<section class="hero tw-pt-[100px] sm:tw-p-auto">
    <div
        class="tw-text-[#0441AB] tw-bg-[#A99CFB] tw-text-center tw-z-20 tw-absolute tw-right-0 tw-top-[50px] tw-p-[10px] tw-w-[275px] tw-leading-[1.5] tw-rounded-l-[7px]"
    >
        <span [innerHTML]="'GRANTS.BUBBLE_TEXT' | translate"></span>
    </div>
    <img
        class="tw-absolute tw-left-0 tw-w-full tw-h-full tw-opacity-50"
        src="/assets/images/miti/hero-vector.svg"
        alt="Hero-vector"
    />
    <div
        class="tw-max-w-[1200px] tw-w-full tw-mx-auto tw-px-[20px] tw-my-[50px] tw-relative tw-z-[2]"
    >
        <h1
            [innerHTML]="'GRANTS.PAGE_TITLE' | translate"
            class="!tw-text-[2rem] !tw-leading-[1.5] lg:!tw-text-[5rem] md:!tw-text-[4rem] md:!tw-leading-[75px] tw-text-center md:tw-text-left lg:!tw-leading-[90px] tw-mb-[40px] !tw-font-semibold"
        ></h1>

        <div
            class="tw-flex tw-flex-col tw-max-w-[85%] md:tw-max-w-full tw-mx-auto tw-text-center md:tw-text-left tw-gap-[20px] md:tw-flex-row tw-items-center tw-justify-between tw-py-[15px] tw-px-[30px] tw-bg-[#0F268F] tw-rounded-[12px]"
        >
            <p class="!tw-m-0">
                {{ "GRANTS.START_TITLE" | translate }}
            </p>
            <button
                ga-event-id="start_button_main_banner_button_grants_click"
                ga-event-category="Grants Button"
                ga-event-label="Start Button Main Banner Main Button Click"
                ga-track="track"
                (click)="openDialog()"
                class="tw-bg-white tw-px-[40px] tw-py-[10px] tw-rounded-full tw-text-black"
            >
                {{ "GRANTS.START" | translate }}
            </button>
        </div>
    </div>
</section>
